import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const fetchAllMessages = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.messages
        .fetchAllMessages(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_MESSAGES_FAILED,
              reject: actionTypes.FETCH_MESSAGES_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_MESSAGES_LOADING);
  const success = res => action(actionTypes.FETCH_MESSAGES_SUCCESS, res);

  return request();
};

export const fetchAllMessageReceivers = (id, query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.messages
        .fetchAllMessageReceivers(id, query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_MESSAGE_RECEIVERS_FAILED,
              reject: actionTypes.FETCH_MESSAGE_RECEIVERS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_MESSAGE_RECEIVERS_LOADING);
  const success = res => action(actionTypes.FETCH_MESSAGE_RECEIVERS_SUCCESS, res);

  return request();
};

export const fetchAllDiscountCodes = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.messages
        .fetchAllDiscountCodes(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_FAILED,
              reject: actionTypes.FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_DISCOUNT_CODES_FOR_RECEIVERS_SUCCESS, res);

  return request();
};

export const sendMessage = (
  messageTitle,
  messageBody,
  isPublished,
  expiration,
  specialUserIds,
  receiverType,
  minOrderInReservationValue,
  minSuccessfulReservationValue,
  discountCode
) => {
  console.log('messageTitle', messageTitle);
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.messages
        .sendMessage({
          messageTitle,
          messageBody,
          isPublished,
          expiration,
          specialUserIds,
          receiverType,
          minOrderInReservationValue,
          minSuccessfulReservationValue,
          discountCode
        })
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.SEND_MESSAGE_FAILED,
              reject: actionTypes.SEND_MESSAGE_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.SEND_MESSAGE_LOADING);
  const success = res => action(actionTypes.SEND_MESSAGE_SUCCESS, res);

  return request();
};

export const fetchMessageById = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.messages
        .fetchMessageById(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_MESSAGE_BY_ID_FAILED,
              reject: actionTypes.FETCH_MESSAGE_BY_ID_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_MESSAGE_BY_ID_LOADING);
  const success = res => action(actionTypes.FETCH_MESSAGE_BY_ID_SUCCESS, res);

  return request();
};

export const emptyMessageObject = () => {
  return dispatch => dispatch(action(actionTypes.EMPTY_MESSAGE_OBJECT));
};
